import createModule from "modules/createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { VIEW_TYPES } from "helpers/base"
import { convertPositionSetType } from "helpers/compositeSecurities"
import { getIsOpPro } from "modules/account-root/selectors"
import { getOnly, getDisabled, getFocusedChartLine } from "./selectors"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getAvailableSelectViewFactors, getFactorCategoryId, getAllCategoryItems } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getPerformanceFetchStartDate } from "./selectors/dates"
import { getFirstPerformanceDate, getPerformanceHistory } from "./selectors/performance"
import { getCurrency } from "modules/analyze-composite-security/selectors"
import { getIsRfrAttributionEnabled } from "selectors/features"
import { getResidualAttributionSummarySubquery } from "helpers/residualAttribution"

export default createModule({
  view,
  externalProps: (state, props) => ({
    performanceFetchStartDate: getPerformanceFetchStartDate(state, props),
    isRfrAttributionEnabled: getIsRfrAttributionEnabled(state),
  }),
  data: [{
    resource: "analyzeCompositePerformance",
    as: null,
    url: ({ positionSetType, positionSetId, modelId, portfolioId, endDate, base, viewType, baseSignature, performanceFetchStartDate, segment, expand, currency, isRfrAttributionEnabled }) => {
      return {
        id: `analyzeCompositePerformance-${modelId}${positionSetType}${positionSetId}${performanceFetchStartDate}${endDate}${viewType}${baseSignature}${JSON.stringify(segment)}${expand}${currency}${isRfrAttributionEnabled}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model (id: $modelId) {
            simulation (positionSet: $positionSet, from: $from, to: $to, base: $base, interval: AUTO) {
              performance {
                date
                totalReturn {
                  cumulativePercent
                }
                attribution {
                  summary {
                    factors {
                      cumulativePercent
                    }
                    specific {
                      cumulativePercent
                    }
                    trading {
                      cumulativePercent
                    }
                    ${isRfrAttributionEnabled ? getResidualAttributionSummarySubquery() : ""}
                  }
                  factors {
                    id
                    category
                    name
                    return {
                      cumulativePercent
                    }
                  }
                }
              },
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          portfolioId,
          from: performanceFetchStartDate,
          to: endDate,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    firstDate: getFirstPerformanceDate(state, props),
    data: getFilteredData(state, props),
    performanceHistory: getPerformanceHistory(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    selectedOption: getSelectedOption(state, props),
    fileName: getFileName(state, props),
    factorCategoryId: getFactorCategoryId(state, props),
    isOpPro: getIsOpPro(state),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    only: getOnly(state),
    disabled: getDisabled(state),
    focusedChartLine: getFocusedChartLine(state),
    currency: getCurrency(state),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
